import { TypeCategorySortingSkeleton } from '~/types/contentful'
import { Categories } from '../Categories'
import type { FC } from 'react'
import { Entry } from 'contentful'

export type BlogProps = {
  categories: Entry<TypeCategorySortingSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS', string>
  children?: React.ReactNode
}

export const Blog: FC<BlogProps> = ({ categories, children }) => {
  return (
    <div className="relative m-[calc(-1_*_var(--header-height))_-32px_0] max-md:m-[calc(-1_*_var(--header-height))_-18px_0] max-lg:m-[calc(-1_*_var(--header-height))_-26px_0]">
      <div className="absolute left-8 top-0 h-full w-60 z-[2] max-xl:hidden pt-[calc(var(--header-height)_+_55px)]">
        <Categories categoriesInfo={categories} />
      </div>
      <div>{children}</div>
    </div>
  )
}
